import { progress } from '../actions/actionTypes';
export const initialState = {
    loading: false,
};
export default function (state = initialState, action) {
    switch (action.type) {
        case progress.START_LOADING:
            return { ...state, loading: true };
        case progress.END_LOADING:
            return { ...state, loading: false };
        default:
            return state;
    }
}
